// Important: this needs to be updated if form fields get added/moved to different sections
export const getErroredAccordionIndexes = ({ errors }) => {
  // each index corresponds to a section in the accordion
  const accordionSectionFields = [
    ['name', 'icon', 'description', 'url'],
    ['categories'],
    ['filters'],
    ['tags', 'longDescription'],
  ];

  const erroredIndexes = [];

  accordionSectionFields.forEach((section, i) => {
    if (section.some((fieldName) => fieldName in errors)) {
      erroredIndexes.push(i);
    }
  });

  return erroredIndexes;
};
